export const authenticationLocalization = {
  AdministrativEnhetOff: {
    en: 'Administrative Unit',
    nn: 'Administrativ eining',
    nb: 'Administrativ enhet',
  },
  BestyrendeReder: {
    en: 'Managing Shipowner',
    nn: 'Styrande reiar',
    nb: 'Bestyrende reder',
  },
  Bobestyrer: {
    en: 'Estate Administrator',
    nn: 'Bustyrar',
    nb: 'Bobestyrer',
  },
  DagligLeder: {
    en: 'General Manager',
    nn: 'Dagleg leiar',
    nb: 'Daglig leder',
  },
  DeltagerMedProratariskAnsvar: {
    en: 'Participant with Pro Rata Liability',
    nn: 'Deltakar med proratarisk ansvar',
    nb: 'Deltager med proratarisk ansvar',
  },
  DeltagerMedSolidariskAnsvar: {
    en: 'Participant with Joint Liability',
    nn: 'Deltakar med solidarisk ansvar',
    nb: 'Deltager med solidarisk ansvar',
  },
  Eierkommune: {
    en: 'Owner Municipality',
    nn: 'Eigarkommune',
    nb: 'Eierkommune',
  },
  Forretningsfoerer: {
    en: 'Business Manager',
    nn: 'Forretningsførar',
    nb: 'Forretningsfører',
  },
  OpplysningerOmForetaketIHjemlandet: {
    en: 'Information about the Company in the Home Country',
    nn: 'Opplysningar om føretaket i heimlandet',
    nb: 'Opplysninger om foretaket i hjemlandet',
  },
  Helseforetak: {
    en: 'Health Enterprise',
    nn: 'Helseføretak',
    nb: 'Helseforetak',
  },
  Innehaver: {
    en: 'Proprietor',
    nn: 'Innehavar',
    nb: 'Innehaver',
  },
  Konkursdebitor: {
    en: 'Bankruptcy Debtor',
    nn: 'Konkursdebitor',
    nb: 'Konkursdebitor',
  },
  DenPersonligeKonkursenAngaar: {
    en: 'Person Affected by Bankruptcy',
    nn: 'Personen konkursen gjeld',
    nb: 'Den personlige konkursen angår',
  },
  InngaarIKirkeligFellesraad: {
    en: 'Part of Church Council',
    nn: 'Inngår i kyrkjeleg fellesråd',
    nb: 'Inngår i kirkelig fellesråd',
  },
  Komplementar: {
    en: 'General Partner',
    nn: 'Komplementær',
    nb: 'Komplementar',
  },
  Kontaktperson: {
    en: 'Contact Person',
    nn: 'Kontaktperson',
    nb: 'Kontaktperson',
  },
  InngaarIKontorfellesskap: {
    en: 'Part of Office Community',
    nn: 'Inngår i kontorfellesskap',
    nb: 'Inngår i kontorfellesskap',
  },
  StyretsLeder: {
    en: 'Chair of the Board',
    nn: 'Styreleiar',
    nb: 'Styrets leder',
  },
  Styremedlem: {
    en: 'Board Member',
    nn: 'Styremedlem',
    nb: 'Styremedlem',
  },
  Nestleder: {
    en: 'Deputy Chair',
    nn: 'Nestleiar',
    nb: 'Nestleder',
  },
  Observatoer: {
    en: 'Observer',
    nn: 'Observatør',
    nb: 'Observatør',
  },
  ErSaerskiltOppdeltEnhetTil: {
    en: 'Is a Special Subdivision Unit Of',
    nn: 'Er særskilt oppdelt eining til',
    nb: 'Er særskilt oppdelt enhet til',
  },
  OrganisasjonsleddIOffentligSektor: {
    en: 'Organizational Unit in Public Sector',
    nn: 'Organisasjonsledd i offentleg sektor',
    nb: 'Organisasjonsledd i offentlig sektor',
  },
  Regnskapsfoerer: {
    en: 'Accountant',
    nn: 'Rekneskapsførar',
    nb: 'Regnskapsfører',
  },
  NorskRepresentantForUtenlandskEnhet: {
    en: 'Norwegian Representative for Foreign Entity',
    nn: 'Norsk representant for utanlandsk eining',
    nb: 'Norsk representant for utenlandsk enhet',
  },
  Revisor: {
    en: 'Auditor',
    nn: 'Revisor',
    nb: 'Revisor',
  },
  Varamedlem: {
    en: 'Deputy Member',
    nn: 'Varamedlem',
    nb: 'Varamedlem',
  },
  Privatperson: {
    en: 'Private Individual',
    nn: 'Privatperson',
    nb: 'Privatperson',
  },
  Prokura: {
    en: 'Procuration Holder',
    nn: 'Prokura',
    nb: 'Prokura',
  },
  Signatur: {
    en: 'Authorized Signatory',
    nn: 'Signatur',
    nb: 'Signatur',
  },
  Avklaring: {
    en: 'Clarification',
    nn: 'Avklaring',
    nb: 'Avklaring',
  },

  formSubmitErrorTitle: {
    nb: 'Du er ikke berettiget til å sende inn',
    nn: 'Du har ikkje rett til å sende det inn',
    en: 'You are not eligible to submit it',
  },

  formSubmitErrorDescription: {
    nb: 'Personer må ha en av følgende roller:',
    nn: 'Personar må ha ei av dei følgjande rollene:',
    en: 'Individuals must have one of the following roles:',
  },
} as const;
